<template>
  <div style="clear: both">
    <v-textarea
      :label="$t('Title')"
      :error-messages="modelValue && modelValue.length > 0 ? null : ' '"
      :rules="titleRules"
      name="title"
      :readonly="readonly"
      variant="underlined"
      :model-value="modelValue"
      v-on:update:model-value="updateValue($event)"
      ref="title"
      :placeholder="$t('Rule_Required_Title')"
      auto-grow
      rows="1"
      dense
      persistent-placeholder   
      density="comfortable"   
    ></v-textarea>
  </div>
</template>

<script>
import { FormStatus, Roles } from '@/common'
import { Flags } from '@/common/flags'
export default {
  emits: ['update:modelValue'],
  name: 'TitleField',
  data: () => ({
    minimumTitleLength: 1,
    maximumTitleLength: 256
  }),
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    roles: {
      type: Array,
      default: null
    },
    previousFormStatus: {
      type: Object
    },
    moc: {
      type: Object
    }
  },
  computed: {
    readonly: function () {
      switch (this.moc.status.value) {
        case FormStatus.properties[FormStatus.NEW].value:
          if (
            this.roles.includes(Roles.properties[Roles.INITIATOR].value) ||
            this.roles.includes(Roles.properties[Roles.COINITIATOR].value)
          ) {
            return false
          }
          break
        case FormStatus.properties[FormStatus.DRAFT].value:
          if (
            this.roles.includes(Roles.properties[Roles.INITIATOR].value) ||
            this.roles.includes(Roles.properties[Roles.COINITIATOR].value)
          ) {
            return false
          }
          break
        case FormStatus.properties[FormStatus.SUBMITTED].value:
          if (
            (this.moc.flags || []).includes(Flags.properties[Flags.MULTIPASS].key) &&
            (this.roles.includes(Roles.properties[Roles.FACILITATOR].value) ||
              this.roles.includes(Roles.properties[Roles.FACILITATORBACKUP].value) ||
              this.roles.includes(Roles.properties[Roles.OWNER].value))
          ) {
            return false
          }
          break
        case FormStatus.properties[FormStatus.AVAILABLETOIMPLEMENT].value:
          if (this.roles.includes(Roles.properties[Roles.OWNER].value)) {
            if (this.moc.flags && this.moc.flags.includes(Flags.properties[Flags.OWNEREDITABLEMAKEPERMANENT].key)) {
              return false
            }
          }
          break
        case FormStatus.properties[FormStatus.SENTBACKFORCORRECTIONS].value:
          if (
            this.roles.includes(Roles.properties[Roles.INITIATOR].value) ||
            this.roles.includes(Roles.properties[Roles.COINITIATOR].value)
          ) {
            return false
          }
          break
        case FormStatus.properties[FormStatus.BEINGREVISED].value:
          if (
            (this.previousFormStatus.value === FormStatus.properties[FormStatus.AVAILABLEFORDECISION].value ||
              this.previousFormStatus.value === FormStatus.properties[FormStatus.PENDINGOWNERDECISION].value ||
              this.previousFormStatus.value === FormStatus.properties[FormStatus.AVAILABLETOIMPLEMENT].value) &&
            (this.roles.includes(Roles.properties[Roles.INITIATOR].value) ||
              this.roles.includes(Roles.properties[Roles.COINITIATOR].value) ||
              this.roles.includes(Roles.properties[Roles.OWNER].value))
          ) {
            return false
          }

          if (
            this.previousFormStatus.value === FormStatus.properties[FormStatus.AVAILABLETOIMPLEMENT].value &&
            (this.roles.includes(Roles.properties[Roles.COORDINATOR].value) ||
              this.roles.includes(Roles.properties[Roles.OWNER].value))
          ) {
            return false
          }
          break
        case FormStatus.properties[FormStatus.TEMPORARYCHANGEISINPLACEWITHCONSEQUENTIALACTIONSREQUIRED].value:
          if (this.roles.includes(Roles.properties[Roles.OWNER].value)) {
            if (this.moc.flags && this.moc.flags.includes(Flags.properties[Flags.OWNEREDITABLEMAKEPERMANENT].key)) {
              return false
            }
          }
          break
        default:
          return true
      }
      return true
    },
    titleRules: {
      get: function () {
        return [
          (v) => !!v || ' ',
          (v) =>
            (v && v.trim().length >= this.minimumTitleLength) ||
            this.$t('Rule_MinimumLength', { length: this.minimumTitleLength }),
          (v) =>
            (v && v.trim().length <= this.maximumTitleLength) ||
            this.$t('Rule_MaximumLength', { length: this.maximumTitleLength })
        ]
      }
    }
  },
  methods: {
    updateValue: function (value) {
      // this.$emit('input', value)
      this.$emit('update:modelValue', value)
    }
  }
}
</script>

<style>
.v-field__input{
  overflow-y:hidden;
}
</style>
